import React, { useState } from 'react';
import { buildDisplayNameMap } from '../utils/portfolioNames';

const StressTestTable = ({ stressTestResults, portfolioRegistry }) => {
    const nameMap = buildDisplayNameMap(portfolioRegistry);
    const displayName = (code) => nameMap[code] || code;
    const filteredResults = stressTestResults.filter(
        event => event.top_contributors.length > 0 || event.portfolio_return !== 0
    );

    const [selectedIndex, setSelectedIndex] = useState(0);

    if (filteredResults.length === 0) {
        return (
            <div className="text-center text-muted py-5">
                No stress test data available
            </div>
        );
    }

    const event = filteredResults[selectedIndex];

    return (
        <div>
            <div className="mb-3">
                <select
                    className="form-select"
                    value={selectedIndex}
                    onChange={(e) => setSelectedIndex(Number(e.target.value))}
                    style={{ borderColor: '#599BE3', maxWidth: '400px' }}
                >
                    {filteredResults.map((evt, index) => (
                        <option key={index} value={index}>
                            {evt.event_name} ({(evt.portfolio_return * 100).toFixed(2)}%)
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-2">
                <small className="text-muted">
                    {event.start_date} to {event.end_date}
                </small>
                {event.description && (
                    <small className="text-muted ms-2">— {event.description}</small>
                )}
            </div>
            <table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.85rem' }}>
                <thead style={{ backgroundColor: '#072040', color: '#fff' }}>
                    <tr>
                        <th>Asset Class</th>
                        <th className="text-end">Weight (%)</th>
                        <th className="text-end">Asset Class Return (%)</th>
                        <th className="text-end">Contribution (%)</th>
                    </tr>
                </thead>
                <tbody>
                    {event.top_contributors.map((contributor, cIdx) => (
                        <tr key={cIdx}>
                            <td>{displayName(contributor.asset_class)}</td>
                            <td className="text-end">
                                {contributor.weight != null
                                    ? (contributor.weight * 100).toFixed(2)
                                    : '-'}
                            </td>
                            <td className="text-end">
                                {contributor.asset_return != null
                                    ? (contributor.asset_return * 100).toFixed(2)
                                    : '-'}
                            </td>
                            <td
                                className="text-end"
                                style={{
                                    color: contributor.contribution >= 0 ? '#198754' : '#dc3545',
                                    fontWeight: 500,
                                }}
                            >
                                {(contributor.contribution * 100).toFixed(2)}
                            </td>
                        </tr>
                    ))}
                    <tr style={{ backgroundColor: '#E7E6E6', fontWeight: 'bold' }}>
                        <td>Portfolio Total</td>
                        <td className="text-end">-</td>
                        <td className="text-end">-</td>
                        <td
                            className="text-end"
                            style={{
                                color: event.portfolio_return >= 0 ? '#198754' : '#dc3545',
                            }}
                        >
                            {(event.portfolio_return * 100).toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default StressTestTable;
